<!-- eslint-disable vue/no-unused-components -->
<!--
 * @Description: 添加或编辑
 * @Author: Neo
 * @Date: 2019-12-11
 * @LastEditTime: 2021-11-17
 * @LastEditors: Neo
-->
<template>
  <div class="multiImgSelect">
    <el-popover
      :placement="placement"
      :width="screenWidth"
      trigger="click"
      popper-class="popperScreen"
      :title="title"
      ref="popoverSH"
    >
      <div slot="reference" class="selectStyle mt5 ml10">
        <el-badge
          :value="imgList.length"
          :hidden="imgList.length === 0"
          class="imgNumBadge"
        >
          <i class="el-icon-picture"></i>
        </el-badge>
      </div>

      <div>
        <ImgUpload
          ref="imgUploadRef"
          v-model="imgList"
          :uploadFixData="imgUploadPreFixData"
          @viewerClose="imgViewerClose"
        />
        <!-- <div>{{ imgList }}</div> -->
      </div>

      <div style="text-align: center; margin: 10px 0 0 0">
        <el-button
          size="mini"
          type="primary"
          class="smallBtn"
          @click="directSendImg"
          :disabled="imgList.length === 0"
          v-show="!hideSendBtn"
        >
          直接发送
        </el-button>

        <el-button size="mini" class="skyBtn" @click="reset">清空</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import ImgUpload from '@/components/common/ImgUpload/index.vue'
import { mapState } from 'vuex'

export default {
  name: 'multiImgSelect',
  components: { ImgUpload },
  props: {
    // 箭头位置
    placement: {
      type: String,
      default: 'top',
    },
    // 宽度
    screenWidth: {
      type: String,
      default: '580',
    },
    // 标题
    title: {
      type: String,
      default: '请上传图片',
    },
    // 隐藏发送按钮
    isHideSendBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgList: [
        // {
        //   filepath: '/group1/M00/14/B7/AjEDD2SBT_GAGlkJAABcJJG7czA854.jpg',
        //   fmt: 'jpg',
        //   height: 300,
        //   message: '操作成功！',
        //   requestid: null,
        //   size: 23588,
        //   statuscode: 200,
        //   thumbfilepath: '/group1/M00/14/B7/AjEDD2SBT_GAGlkJAABcJJG7czA854.jpg',
        //   thumburl:
        //     'https://cms.xkb.com.cn/storage/group1/M00/14/B7/AjEDD2SBT_GAGlkJAABcJJG7czA854.jpg',
        //   url: 'https://cms.xkb.com.cn/storage/group1/M00/14/B7/AjEDD2SBT_GAGlkJAABcJJG7czA854.jpg',
        //   width: 534,
        // }
      ],
      hideSendBtn: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.player.userInfo,
      imgUploadPreFixData: (state) => {
        const tenantId = state?.player?.userInfo?.tenantId
        return {
          tenantId: tenantId === 'STCN' ? 1 : tenantId,
          type: 'tuwen',
        }
      },
    }),
  },
  created() {},
  mounted() {},
  methods: {
    directSendImg() {
      this.$emit('directSendImg')
    },
    reset() {
      this.imgList = [];
      this.$refs.imgUploadRef.reset()
    },

    // 监听图片预览弹窗关闭
    imgViewerClose() {
      setTimeout(() => {
        this.$refs.popoverSH.doShow() // 打开
      }, 5)
    },

    // 赋值
    setImgList(_imgList) {
      this.imgList = _imgList;
    },
  },
  watch: {
    // 因为有时页面不更新，所以加个监听，赋值
    isHideSendBtn: {
      handler(val) {
        this.hideSendBtn = Boolean(val)
      },
      deep: true,
    },
  },
  beforeDestroy() {},
  destroyed() {},
}
</script>

<style>
.el-popover.popperScreen {
  margin-top: 5px !important;
}
</style>

<style scoped>
.multiImgSelect {
  display: inline-block;
  font-size: 24px;
  color: #666;
  cursor: pointer;
}
</style>
